import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollManager = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      requestAnimationFrame(() => {
        let id = hash.slice(1);
        try { id = decodeURIComponent(id); } catch { /* keep the raw fragment */ }
        document.getElementById(id)?.scrollIntoView();
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, key]);

  return null;
};

export default ScrollManager;
